export enum EstadoRemitoCargamento {
  Iniciado = 0,
  AptoCalidad = 1,
  AptoCantidad = 2,
  MedicionFinal = 3,
  Finzalizado = 4,
  Anulado = 5,
  Pendiente = 6,
  Rechazado = 7
}